@if (isOpen) {
<div class="fixed inset-0 z-modal flex items-center justify-center">
  <div class="absolute inset-0 bg-black/40" (click)="cancelar()"></div>
  <div class="relative bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-md mx-4 sm:mx-6 max-h-[85vh] flex flex-col">

    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Solicitar aprobación interna</h3>
        @if (quoteNumber) {
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ quoteNumber }}</p>
        }
      </div>
      <button type="button" (click)="cancelar()" [disabled]="submitting"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors disabled:opacity-50">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-4 space-y-4">
      <p class="text-sm text-gray-600 dark:text-gray-400">
        La cotización pasará a <span class="font-medium text-violet-600 dark:text-violet-400">Pendiente de Aprobación</span>
        y el aprobador recibirá un correo con un enlace para decidir.
      </p>

      @if (error) {
      <div class="px-3.5 py-3 rounded-lg bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800">
        <p class="text-xs text-error-700 dark:text-error-400">{{ error }}</p>
      </div>
      }

      <!-- Selector de aprobador -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Aprobador <span class="text-error-500">*</span>
        </label>
        @if (loadingUsers) {
        <div class="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-dashed border-gray-300 dark:border-gray-600">
          <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-brand-500"></div>
          <span class="text-xs text-gray-500 dark:text-gray-400">Cargando responsables...</span>
        </div>
        } @else {
        <select [(ngModel)]="approverId" [disabled]="submitting"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent disabled:opacity-50">
          <option [ngValue]="null">Selecciona un aprobador...</option>
          @for (approver of approvers; track approver.id) {
          <option [ngValue]="approver.userId">{{ approverLabel(approver) }}</option>
          }
        </select>
        @if (approvers.length === 0) {
        <p class="mt-1 text-xs text-warning-600 dark:text-warning-400">
          No hay responsables de aprobación registrados. Configúralos en Cotizaciones › Responsables de aprobación.
        </p>
        }
        }
      </div>

      <!-- Comentario opcional -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Comentario <span class="text-gray-400 dark:text-gray-500 font-normal">(opcional)</span>
        </label>
        <textarea [(ngModel)]="comment" rows="3" [disabled]="submitting" [maxlength]="COMMENT_MAX"
          placeholder="Ej. Revisar descuento antes de enviar"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:opacity-50 resize-none"></textarea>
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500 text-right">{{ commentLength }}/{{ COMMENT_MAX }}</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-2">
      <button type="button" (click)="cancelar()" [disabled]="submitting"
        class="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors disabled:opacity-50">
        Cancelar
      </button>
      <button type="button" (click)="enviar()" [disabled]="submitting || loadingUsers"
        class="px-4 py-2 text-sm font-medium text-white bg-violet-600 hover:bg-violet-700 rounded-lg transition-colors disabled:opacity-50 flex items-center gap-2">
        @if (submitting) {
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        }
        Enviar solicitud
      </button>
    </div>
  </div>
</div>
}
